export enum ApiErrors {
  AuthenticationError = "AuthenticationError",
  ValidationError = "ValidationError",
  ConfigurationBreakingChangeError = "ConfigurationBreakingChangeError",
  InvalidConfigurationError = "InvalidConfigurationError",
}
